var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductCarousel',{attrs:{"title":_vm.title,"button_link":_vm.getButtonLink(_vm.button_link),"button_text":_vm.button_text,"products":_vm.items,"data-external":"product-carousel-auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }